import {ObjectPictureAssoc, ObjectPictureAssocEntity} from "../../../model/object-picture-assoc";
import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type ObjectPictureAssocSelectorProps = {
  // selector props here
};

export const objectPictureAssocSelector = () => createSelector(
  [getUseQueryResultData<ObjectPictureAssoc>],
  (data) => {
    return data ? transformObjectPictureAssoc(data) : undefined;
  }
);

export const objectPictureAssocsSelector = () => createSelector(
  [getUseQueryResultData<ObjectPictureAssoc[]>],
  (data) => {
    return selectObjectPictureAssocsAndTransform(
      data ?? [], {}
    );
  }
);

export const transformObjectPictureAssoc = (value: ObjectPictureAssoc): ObjectPictureAssocEntity => {
  return ObjectPictureAssocEntity.from(value)
}

export const selectObjectPictureAssocs = (values?: ObjectPictureAssoc[], selector?: ObjectPictureAssocSelectorProps): ObjectPictureAssoc[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;
    return filterIn;
  });
};

export const selectObjectPictureAssocsAndTransform = (values?: ObjectPictureAssoc[], selector?: ObjectPictureAssocSelectorProps): ObjectPictureAssocEntity[] => {
  const selected = selectObjectPictureAssocs(values, selector);
  return selected.map(transformObjectPictureAssoc);
};
